import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=7d64cb8a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d64cb8a')) {
      api.createRecord('7d64cb8a', component.options)
    } else {
      api.reload('7d64cb8a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=7d64cb8a&", function () {
      api.rerender('7d64cb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HcnCGlfH4h0n/JS/cancellationPolicy.vue"
export default component.exports